<template>
	<div class="mainWrapper returns">
		<h1>Product Returns</h1>

		<div class="links">
			<button @click="exportReturns()" class="big-button">
				+ Export
			</button>
		</div>

		<div class="general-search">
			<div>
				<b-field>
					<b-input v-model="searchReturnNumber" placeholder="Return Number" @keyup.native.enter="getReturns"></b-input>
				</b-field>
			</div>

			<div>
				<b-button type="is-info" @click="getReturns()" icon-left="magnify">Search</b-button>
			</div>
		</div>

		<div class="list" v-if="list">
			<div class="return-lists header">
				<div>RETURN NUMBER</div>
				<div>SHOP</div>
				<div>BRAND</div>
				<div>REASON</div>
				<div>STATUS</div>
				<div>CREATED DATE</div>
				<div></div>
			</div>

			<div v-for="(item, index) of list" v-bind:key="index" class="return-lists">
				<div>{{ item.code }}</div>
				<div>{{ item.shop.name }}</div>
				<div>{{ item.brand.name }}</div>
				<div>{{ item.type[0] }}</div>
				<div>{{ displayStatus(item.status) }}</div>
				<div>{{ convertTime(item.createdAt) }}</div>
				<div @click="viewReturnDetail(item._id)" class="hyperlink">
					<ios-arrow-forward-icon w="32px" h="32px" />
				</div>
			</div>
		</div>

		<paginate
			v-model="page"
			:page-count="pageCount"
			:click-handler="pagerClick"
			:prev-text="'prev'"
			:next-text="'next'"
			:container-class="'pagination'"
		>
		</paginate>
	</div>
</template>

<script>
export default {
	name: 'Returns',
	data: function() {
		return {
			limit: this.$config.pageItemsLimit, // For pager
			list: null, // Will contain all the list
			pageCount: 1, // For pager
			page: 1, // For pager
			searchReturnNumber: null
		}
	},
	mounted: async function() {
		await this.getReturns()
	},
	methods: {
		exportReturns: function() {
			this.$router.push('/returns/export')
		},

		getReturns: async function() {
			// Get list of brands
			let data = {
				limit: this.limit,
				populate: ['author', 'shop', 'brand']
			}

			// For Return Number Search
			if (this.searchReturnNumber !== null && this.searchReturnNumber !== '') {
				data.code = this.searchReturnNumber
			}

			const apiGetReturnList = await this.$api.getReturnList({ data })

			this.pageCount = Math.ceil(apiGetReturnList.data.total / this.limit)

			this.list = apiGetReturnList.data.list
		},

		// To display status or not
		displayStatus: function(status = false) {
			if (status == true) {
				return 'OPEN'
			} else {
				return 'CLOSE'
			}
		},

		// When pager is clicked
		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				limit: this.limit,
				skip,
				populate: ['author', 'shop', 'brand']
			}

			// For Return Number Search
			if (this.searchReturnNumber !== null && this.searchReturnNumber !== '') {
				data.code = this.searchReturnNumber
			}

			const apiGetReturnList = await this.$api.getReturnList({ data })

			this.pageCount = Math.ceil(apiGetReturnList.data.total / this.limit)

			this.list = apiGetReturnList.data.list
		},

		// Push to detail page
		viewReturnDetail: function(id) {
			// this.$router.push("/po/detail/" + id);
			this.$router.push({ name: 'returnsDetails', params: { id } })
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/Returns.css';
</style>
